export default {
  line2Title: "choose what community do you want to dive in:".toUpperCase(),
  line3Title: "i want to find to lern about:".toUpperCase(),

  english: "english".toUpperCase(),
  russian: "russian".toUpperCase(),
  chinese: "chinese".toUpperCase(),
  spanish: "spanish".toUpperCase(),
  french: "french".toUpperCase(),

  chat: "chat".toUpperCase(),
  markets: "markets".toUpperCase(),
  forums: "forums".toUpperCase(),
  "top sellers": "top sellers".toUpperCase(),
  essentials: "essentials".toUpperCase(),
  others: "others".toUpperCase(),
}
